import { render, staticRenderFns } from "./FullScreenShow.vue?vue&type=template&id=1fd1f27a&scoped=true"
import script from "./FullScreenShow.vue?vue&type=script&lang=js"
export * from "./FullScreenShow.vue?vue&type=script&lang=js"
import style0 from "./FullScreenShow.vue?vue&type=style&index=0&id=1fd1f27a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd1f27a",
  null
  
)

export default component.exports